// Get content-type constants
export const GET_CONTENT_TYPE_LIST = 'GET_CONTENT_TYPE_LIST';
export const CONTENT_TYPE_REQUEST_GET = 'CONTENT_TYPE_REQUEST_GET';
export const CONTENT_TYPE_RESPONSE_GET_SUCCESS =
	'CONTENT_TYPE_RESPONSE_GET_SUCCESS';
export const CONTENT_TYPE_RESPONSE_GET_FAIL = 'CONTENT_TYPE_RESPONSE_GET_FAIL';
